export default __webpack_public_path__ + "static/media/Wine Thumbnail.17e8b4ca.png";